import * as React from 'react';
import {Button, Grid, TextField} from '@material-ui/core';
import {API} from "aws-amplify";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {Alert} from "@material-ui/lab";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string
    isLoading: boolean
    personId: string
    prescriptionId: string
    response: any
}

class RxEnhancementForHOASection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            errorMessage: '',
            isLoading: false,
            personId: '',
            prescriptionId: '',
            response: ''
        };

        this.setPersonId = this.setPersonId.bind(this);
        this.setPrescriptionId = this.setPrescriptionId.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return (
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <TextField
                        style={{width: 400}}
                        label="Person Id"
                        variant="outlined"
                        value={ this.state.personId }
                        onChange={ this.setPersonId }
                    />
                </Grid>

                <Grid item xs>
                    <TextField
                        style={{width: 400}}
                        label="Prescription Id"
                        variant="outlined"
                        value={ this.state.prescriptionId }
                        onChange={ this.setPrescriptionId }
                    />
                </Grid>

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={this.handleSubmit}>
                        Rx Enhancement
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>HOA Updated Info</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private setPrescriptionId(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ prescriptionId: event.target.value })
    }

    private setPersonId(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ personId: event.target.value })
    }

    private handleSubmit() {
        if (!this.state.personId) {
            alert('Please enter the person id');
        } else if (!this.state.personId.match("^amzn[1-9]+[0-9]*.([A-Za-z0-9]+.)+A[A-Z0-9]*$")) {
            alert('Please enter the valid person id.');
        }

        if (!this.state.prescriptionId) {
            alert('Please enter the prescription Id');
        } else if (!this.state.prescriptionId.match("^[A-Za-z0-9]{24}$")) {
            alert('Please enter the valid prescription id.');
        }

        this.setState({ isLoading: true });

        const apiName = 'ApaqPortalAPI';
        const path = '/prescription/rx-enhancement-for-hoa';
        const config = {
            body: {
                personId: this.state.personId,
                prescriptionId: this.state.prescriptionId,
            },
            headers: {}
        }
        this.callAPI(apiName, path, config);
        this.setState({ isLoading: false });
    }

    private callAPI(apiName: string, path: string, config: any) {
        API.post(apiName, path, config).then((rxEnhancementForHOAResponse: any) => {
            console.log(rxEnhancementForHOAResponse);
            this.setState({ response: rxEnhancementForHOAResponse });
        }).catch((error) => {
            console.log(error);
            this.setState({errorMessage: error.response.data.message});
        })
    }
}

export default RxEnhancementForHOASection
